import {
  put, takeEvery, select,
} from 'redux-saga/effects';
import {
  ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION,
  ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION,
} from '../../constants/actions';
import {
  fetchBuildingsSuccessAction,
  filterBuildingsSuccessAction, setPagesInfo,
} from '../../actions/instances/buildings';
import Api from '../../services/Api';

function* filterBuildings() {
  const { mainFilters } = yield select(state => state.buildings);
  let query = '';
  mainFilters.forEach((filter) => {
    switch (filter.type) {
      case 'city':
        query += `&cities_ids[]=${filter.value}`;
        break;
      case 'dynasty':
        query += `&dynasties_ids[]=${filter.value}`;
        break;
      case 'type':
        query += `&types_ids[]=${filter.value}`;
        break;
      case 'tag':
        query += `&tags_ids[]=${filter.value}`;
        break;
      case 'component':
        query += `&components_ids[]=${filter.value}`;
        break;
      case 'element':
        query += `&elements_ids[]=${filter.value}`;
        break;
      case 'search':
        query += `&search=${encodeURIComponent(filter.value)}`;
        break;
      default:
        query += '';
    }
  });
  const page = mainFilters.find(x => x.type === 'page');
  if (page) {
    query += `&page=${page.value}`;
  }
  const { status, data } = yield Api.get(`instances/buildings?per_page=30${query}`, false);
  if (status === 200) {
    yield put(filterBuildingsSuccessAction(data.data));
    yield put(setPagesInfo({
      from: data.from,
      to: data.to,
      total: data.total,
      last_page: data.last_page,
      per_page: data.per_page,
      current_page: data.current_page,
    }));
  }
}

function* fetchBuildings() {
  const { status, data } = yield Api.get('instances/buildings?per_page=50', false);
  if (status === 200) {
    yield put(fetchBuildingsSuccessAction(data.data));
  }
}

export default function* buildingsSagas() {
  yield takeEvery(ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION, filterBuildings);
  yield takeEvery(ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION, fetchBuildings);
}
